export const UNDERSCORE = '_'
export const PERIOD = '.'
export const COMMA = ','
export const SEMICOLON = ';'
export const COLON = ':'
export const EXCLAMATION_MARK = '!'
export const QUESTION_MARK = '?'
export const SLASH = '/'
export const BACKSLASH = '\\'
export const EM_DASH = '—'
export const QUOTATION_MARK = '"'
export const LEFT_PARENTHESIS = '('
export const RIGHT_PARENTHESIS = ')'
export const LEFT_BRACKET = '['
export const RIGHT_BRACKET = ']'
export const LEFT_BRACE = '{'
export const RIGHT_BRACE = '}'
export const LESS_THAN = '<'
export const GREATER_THAN = '>'
export const AMPERSAND = '&'
export const ASTERISK = '*'
export const EQUALS_SIGN = '='
export const PLUS_SIGN = '+'
export const PIPE = '|'
export const TILDE = '~'
export const GRAVE_ACCENT = '`'
export const CARET = '^'
export const PERCENT_SIGN = '%'
export const DOLLAR_SIGN = '$'
export const HASH_SIGN = '#'
export const AT_SIGN = '@'
export const DANDA = '।'
export const DOUBLE_DANDA = '॥'
export const JAPANESE_COMMA = '、'
export const JAPANESE_PERIOD = '。'
